RivalIQ.apps.AccountSettings.module('models', function (models, App, Backbone, Marionette, $, _) {

    'use strict';

    models.Churn = Backbone.Model.extend({
        url: function () {
            const me = this;
            return `/api/account/${me.get('accountId')}/churn`;
        },

        validate: function (attrs) {
            const errors = [];
            const reason = App.data.churnReasons.get(Number(attrs.churn_reason_id));

            if (!reason) {
                return [['churn_reason_id', 'Please select a reason']];
            }

            if (reason.get('explanation_required') && !attrs.explanation) {
                errors.push(['explanation', 'Please tell us a little more before submitting']);
            }

            if (!errors.length) {
                return null;
            }

            return errors;
        }
    });

});
